import { mapState, mapActions } from 'vuex';

/**
 * * * Must be used along with StoreTableMixin or PaginationOnServerMixin * *
 **/

export default {
  computed: {
    ...mapState('charts', {
      chartState: (state) => state.state,
    }),

    mixStateFilter: {
      get() {
        return this.chartState !== null && this.chartState !== undefined
          ? this.chartState
          : this.getStateFromNamespace.currentTableStateFilter;
      },

      set(value) {
        this.setChartState(null);
        this.setTableStateFilter(value);
        this.fetchTableData();
      },
    },
  },
  methods: {
    ...mapActions('charts', { setChartState: 'setState' }),

    ...mapActions({
      setTableStateFilter(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTableStateFilter`, payload);
      },
    }),
  },
};
